import { defineComponent, h, PropType } from 'vue';
import { FormText } from '@components/form';
import { Dialog } from '@phi/components';
import { State } from '../../state';
import { withSpinner } from '../../state/spinner';
import { without_file_extension } from '@phi/util/file-name';
import { reject_symbols } from '../../keyboard';
import { replace_bad_symbols_and_warn } from '../LoadDefaultObject';
import { export_as_step_to_onshape } from '@phi/export/frontend';
import { display_message_to_user, LOG } from '@phi/logging/frontend';

export default defineComponent({
    props: {
        show: { required: true, type: Boolean },
        default_name: { required: false, type: String, default: default_file_name },
        state: { required: true, type: Object as PropType<State> },
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    data() {
        return {
            name: without_file_extension(this.default_name),
        };
    },

    watch: {
        default_name(value: string) {
            this.name = without_file_extension(value);
        },
    },

    methods: {
        async export_to_onshape_as_step() {
            this.$emit('update:show', false);
            const result = await export_as_step_to_onshape(this.name);
            if (result instanceof Error)
                display_message_to_user(LOG.WARN, result.message);
        },
    },

    render() {
        return h(Dialog, {
            show: this.show,
            'onUpdate:show': x => this.$emit('update:show', x),
            id: 'ExportToOnshapeModal',
            title: 'Send model to Onshape',
            onClose: () => this.$emit('update:show', false),
            onConfirm: withSpinner('Sending to Onshape', this.export_to_onshape_as_step),
            close_label: 'Cancel',
            confirm_label: 'Send to Onshape',
            width: 'narrower',
        }, () => h('label', { class: 'label' }, [
            h('div', { class: 'label-text' }, 'Model name:'),
            h(FormText, {
                value: this.name,
                'onUpdate:value': (x) => this.name = replace_bad_symbols_and_warn(x),
                change: true,
                onKeydown: reject_symbols,
            })
        ]));
    }
});
